module.exports = __webpack_public_path__ + "static/media/guestVideo.31e300e7.mp4";